import postAPI from './postAPI.js'

export default async function postSendOnboardingInvite(body) {
    const data = await postAPI('admin/onboarding/invite', body);
    return data;
}
